import { useState } from "react";
import GuideModal from "./GuideModal";

const DownloadUnificadoButton = ({ selectedYear, selectedSemester }) => {
    const handleDownload = () => {
        const url =
            process.env.REACT_APP_HERMES2_URL +
            process.env.REACT_APP_FOLDER_PROVINCIAS_URL +
            `Territorio_APU_${selectedYear}_${selectedSemester}.xlsx`;
        const link = document.createElement("a");
        link.href = url;
        link.download = "";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const [showGuide, setShowGuide] = useState(false);
    const handleCloseGuide = () => setShowGuide(false);
    const handleShowGuide = () => setShowGuide(true);

    // Mostrar solo si el año es 2025 o mayor
    if (parseInt(selectedYear) < 2025) return null;

    return (
        <div className="text-center mt-3">
            <button
                className="btn btn-outline-dark btn-prop"
                onClick={handleDownload}
                type="button"
                title="Contiene toda la información APU nacional en un solo archivo XLSX"
            >
                Descargar Territorio APU
            </button>
            <button
                className="ms-3 btn btn-prop btn-info"
                onClick={handleShowGuide}
            >
                Guía "Territorio APU"
            </button>

            <GuideModal show={showGuide} onClose={handleCloseGuide} />
        </div>
    );
};

export default DownloadUnificadoButton;
